/** @jsxImportSource @emotion/react */
'use memo'

import styled from '@emotion/styled'
import colors from '@sportninja/common/constants/appColors'
import { paragraphSmall } from 'src/components/css'
import SportIcon from 'src/components/icons/SportIcon'

interface Props {
  /** The sport's display name; '' when the registration has none. */
  sportName: string
}

/** The sport's icon and name; a dash when there is no sport. */
const SportCell = ({ sportName }: Props) => {
  'use memo'

  if (!sportName) {
    return <Wrapper>—</Wrapper>
  }
  return (
    <Wrapper>
      <SportIcon sportName={sportName} size={16} />
      <Name>{sportName}</Name>
    </Wrapper>
  )
}

export default SportCell

const Wrapper = styled.div`
  ${paragraphSmall}
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  height: 100%;
  color: ${colors.WHITE};
`

const Name = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
